import { useEffect, useState } from 'react';
import apiClient from '../../api/client';

let cache = null;
let inflight = null;

const PALETTE = ['green', 'blue', 'red', 'purple', 'amber', 'indigo'];

const FILE_RE = /\.(pdf|jpe?g|png|webp|gif)(\?.*)?$/i;
const SKIP_KEYS = /image|thumb|icon|cover|logo/i;

// Satu sumber kebenaran untuk membentuk URL file
const toUrl = (v) => apiClient.getFileUrl(v);

const collectFiles = (item) => {
    // Kalau API sudah mengirim array files, pakai itu
    if (Array.isArray(item.files) && item.files.length) {
        return item.files
            .map((f) => ({
                title: f.title ?? f.name ?? item.title,
                url: toUrl(f.url ?? f.file_url ?? f.path ?? ''),
            }))
            .filter((f) => f.url);
    }
    // Kalau tidak, cari kolom mana pun yang berisi nama file
    return Object.entries(item)
        .filter(([k, v]) => typeof v === 'string' && FILE_RE.test(v) && !SKIP_KEYS.test(k))
        .map(([, v]) => ({ title: item.title ?? item.name, url: toUrl(v) }));
};

const normalize = (item, i) => {
    const img = item.image ?? item.image_url ?? null;
    return {
        id: item.id,
        title: item.title ?? item.name ?? item.code,
        slug: item.slug ?? item.code,
        description: item.description ?? '',
        color: item.color ?? PALETTE[i % PALETTE.length],
        image: img ? toUrl(img) : null,
        content: item.content ?? item.body ?? '',
        files: collectFiles(item),
    };
};

const fetchList = () => {
    if (cache) return Promise.resolve(cache);
    if (!inflight) {
        inflight = apiClient
            .getFormulirList()
            .then((data) => {
                cache = (data ?? []).map(normalize);
                return cache;
            })
            .catch((err) => {
                console.error('ERROR FORMULIR:', err?.message, err?.response?.status, err?.response?.data);
                throw err;
            })
            .finally(() => { inflight = null; });
    }
    return inflight;
};

export const useFormulirList = () => {
    const [list, setList] = useState(cache ?? []);
    const [loading, setLoading] = useState(!cache);
    const [error, setError] = useState(null);

    useEffect(() => {
        let active = true;
        fetchList()
            .then((data) => { if (active) { setList(data); setLoading(false); } })
            .catch((err) => { if (active) { setError(err); setLoading(false); } });
        return () => { active = false; };
    }, []);

    return { list, loading, error };
};